import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {Lookups, RaceAdditionalPricingItem} from "@model";
import {transformValueAndCurrency} from "@utility";
import {TranslocoService} from "@ngneat/transloco";

@Component({
    selector: 'app-register-to-race-additional-item-output',
    templateUrl: './register-to-race-additional-item-output.component.html',
    styleUrls: ['./register-to-race-additional-item-output.component.scss'],
    animations: [
        trigger('fadeInAnimation', [
            state('in', style({ opacity: 1 })),
            transition(':enter', [
                style({ opacity: 0 }),
                animate(1600)
            ])
        ])
    ],
    standalone: false
})
export class RegisterToRaceAdditionalItemOutput implements OnChanges {
  @Input() eventCurrencyLabel: string | undefined;
  @Input() defaultLanguage?: number;
  @Input() raceAdditionalPricingItem: RaceAdditionalPricingItem | undefined;
  @Input({required:true}) languages: Lookups[] = [];

  price: string = "";
  constructor(private translocoService: TranslocoService) {
  }

  ngOnInit() {
    this.price = this.getPriceLabel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.price = this.getPriceLabel();
  }

  getPriceLabel(): string {
    let price: string = "";
    if (!!this.raceAdditionalPricingItem?.priceConstant || (this.raceAdditionalPricingItem!.pricingItemValues?.length ?? 0) === 0) {
      price = transformValueAndCurrency(this.raceAdditionalPricingItem?.price, this.translocoService.getActiveLang()) + " " + this.eventCurrencyLabel;
    } else if (this.raceAdditionalPricingItem!.pricingItemValues?.length === 1 && this.raceAdditionalPricingItem!.pricingItemValues[0].price !== undefined) {
      price = transformValueAndCurrency(this.raceAdditionalPricingItem!.pricingItemValues[0].price, this.translocoService.getActiveLang()) + " " + this.eventCurrencyLabel;
    }
    return `${price !== "" ?  "- " : ""} ${price}`;
  }
}
